// 1.


// import React, { useEffect, useState, useContext, forwardRef } from "react";
// import {
//   Chart as ChartJS,
//   LinearScale,
//   CategoryScale,
//   Tooltip,
//   Legend,
// } from "chart.js";
// import { MatrixController, MatrixElement } from "chartjs-chart-matrix";
// import ChartDataLabels from "chartjs-plugin-datalabels";
// import { Chart } from "react-chartjs-2";
// import { Refresh } from "@mui/icons-material";
// import IconButton from "@mui/material/IconButton";
// import CircularProgress from "@mui/material/CircularProgress";
// import { AuthenticationContext } from "../../../../../context/AuthenticationContext";
// import { BusinessApi } from "../../../../../api/Api";
// import BusinessInnerSimpleChart4 from "./BusinessInnerSimpleChart4";

// /* ✅ Register ONLY required chart.js components (NO DataLabels globally) */
// ChartJS.register(
//   LinearScale,
//   CategoryScale,
//   MatrixController,
//   MatrixElement,
//   Tooltip,
//   Legend
// );

// const BusinessInnerChart4 = forwardRef((props, ref) => {
//   const { LoggedInUserInfo } = useContext(AuthenticationContext);
//   const [rawData, setRawData] = useState([]);
//   const [loading, setLoading] = useState(false);

//   const fetchLogData = async () => {
//     setLoading(true);
//     try {
//       const res = await BusinessApi({
//         LOGIN_ID: localStorage.getItem("LOGIN_ID") || "",
//         SS_KEY: localStorage.getItem("SS_KEY") || "",
//       });
//       setRawData(Array.isArray(res?.data) ? res.data : []);
//     } catch (err) {
//       console.error(err);
//     } finally {
//       setLoading(false);
//     }
//   };

//   useEffect(() => {
//     fetchLogData();
//   }, []);

//   /* 🔥 X-axis labels */
//   const users = rawData.map((d, i) => d.user || `User-${i + 1}`);

//   /* 🔥 Heatmap data */
//   const heatMapData = rawData.map((d, x) => ({
//     x,
//     y: 0,
//     v: Number(d.TODAYS_Specific_Yield) || 0,
//   }));

//   return (
//     <>
//       <div ref={ref} className="row">
//         <div className="col-md-12" style={{ height: "26rem", position: "relative" }}>

//           {/* 🔄 Refresh */}
//           <div style={{ position: "absolute", top: 10, right: 10, zIndex: 1 }}>
//             <IconButton onClick={fetchLogData} disabled={loading}>
//               <Refresh />
//             </IconButton>
//           </div>

//           {loading ? (
//             <div className="d-flex justify-content-center align-items-center h-100">
//               <CircularProgress />
//             </div>
//           ) : (
//             <Chart
//               type="matrix"
//               plugins={[ChartDataLabels]}   // ✅ DataLabels ONLY for this chart
//               data={{
//                 datasets: [
//                   {
//                     data: heatMapData,

//                     backgroundColor: (ctx) => {
//                       const v = ctx.raw?.v ?? 0;
//                       if (v === 0) return "#ff0000";
//                       if (v < 1) return "#ff8c00";
//                       if (v < 1.5) return "#ffff00";
//                       if (v < 1.8) return "#7CFC00";
//                       return LoggedInUserInfo?.dash_color || "#00c853";
//                     },

//                     width: ({ chart }) =>
//                       chart.chartArea
//                         ? chart.chartArea.width / users.length
//                         : 30,

//                     height: ({ chart }) =>
//                       chart.chartArea
//                         ? chart.chartArea.height / 2
//                         : 40,
//                   },
//                 ],
//               }}
//               options={{
//                 responsive: true,
//                 maintainAspectRatio: false,

//                 plugins: {
//                   legend: { display: false },

//                   tooltip: {
//                     callbacks: {
//                       label: (ctx) =>
//                         `${users[ctx.raw?.x]} : ${ctx.raw?.v}`,
//                     },
//                   },

//                   /* ✅ DataLabels ONLY here */
//                   datalabels: {
//                     display: true,
//                     formatter: (ctx) => ctx?.v?.toFixed(2),
//                     color: "#000",
//                     font: {
//                       size: 12,
//                       weight: "bold",
//                     },
//                   },
//                 },

//                 scales: {
//                   x: {
//                     type: "linear",
//                     position: "bottom",
//                     ticks: {
//                       callback: (val) => users[val],
//                       maxRotation: 45,
//                       minRotation: 45,
//                       font: { size: 10 },
//                     },
//                   },

//                   y: {
//                     type: "category",
//                     offset: true,
//                     title: {
//                       display: true,
//                       text: "Today Specific Yield",
//                       font: { weight: "bold" },
//                     },
//                     ticks: {
//                       font: { size: 12 },
//                     },
//                   },
//                 },


//               }}
//             />
//           )}
//         </div>
//       </div>

//       <BusinessInnerSimpleChart4 />
//     </>
//   );
// });

// export default BusinessInnerChart4;



// 2.

import React, { useEffect, useState, useContext, forwardRef } from "react";
import {
  Chart as ChartJS,
  LinearScale,
  CategoryScale,
  Tooltip,
  Legend,
} from "chart.js";
import { MatrixController, MatrixElement } from "chartjs-chart-matrix";
import ChartDataLabels from "chartjs-plugin-datalabels";
import { Chart } from "react-chartjs-2";
import { Refresh } from "@mui/icons-material";
import IconButton from "@mui/material/IconButton";
import CircularProgress from "@mui/material/CircularProgress";
import { AuthenticationContext } from "../../../../../context/AuthenticationContext";
import { BusinessApi } from "../../../../../api/Api";
import BusinessInnerSimpleChart4 from "./BusinessInnerSimpleChart4";

/* ✅ Register ONLY required components */
ChartJS.register(
  LinearScale,
  CategoryScale,
  MatrixController,
  MatrixElement,
  Tooltip,
  Legend
);

const BusinessInnerChart4 = forwardRef((props, ref) => {
  const { LoggedInUserInfo } = useContext(AuthenticationContext);
  const [rawData, setRawData] = useState([]);
  const [loading, setLoading] = useState(false);

  const fetchLogData = async () => {
    setLoading(true);
    try {
      const res = await BusinessApi({
        LOGIN_ID: localStorage.getItem("LOGIN_ID") || "",
        SS_KEY: localStorage.getItem("SS_KEY") || "",
      });
      setRawData(Array.isArray(res?.data) ? res.data : []);
    } catch (err) {
      console.error(err);
    } finally {
      setLoading(false);
    }
  };

  useEffect(() => {
    fetchLogData();
  }, []);

  /* 🔥 X-axis labels (ALL users) */
  const users = rawData.map(
    (d, i) => d.user || `User-${i + 1}`
  );

  /* 🔥 Matrix heatmap data (CATEGORY based) */
  const heatMapData = rawData.map((d, i) => ({
    x: users[i],                         // 🔥 category value
    y: "Today Specific Yield",            // single row
    v: Number(d.TODAYS_Specific_Yield) || 0,
  }));

  return (
    <>
      <div ref={ref} className="row">
        <div
          className="col-md-12"
          style={{ height: "26rem", position: "relative" }}
        >
          {/* 🔄 Refresh */}
          <div style={{ position: "absolute", top: 10, right: 10, zIndex: 1 }}>
            <IconButton onClick={fetchLogData} disabled={loading}>
              <Refresh />
            </IconButton>
          </div>

          {loading ? (
            <div className="d-flex justify-content-center align-items-center h-100">
              <CircularProgress />
            </div>
          ) : (
            <Chart
              type="matrix"
              plugins={[ChartDataLabels]}   // ✅ only here
              data={{
                datasets: [
                  {
                    data: heatMapData,

                    backgroundColor: (ctx) => {
                      const v = ctx.raw?.v ?? 0;
                      if (v === 0) return "#ff0000";
                      if (v < 1) return "#ff8c00";
                      if (v < 1.5) return "#ffff00";
                      if (v < 1.8) return "#7CFC00";
                      return LoggedInUserInfo?.dash_color || "#00c853";
                    },

                    width: ({ chart }) =>
                      chart.chartArea
                        ? chart.chartArea.width / users.length
                        : 30,

                    height: ({ chart }) =>
                      chart.chartArea
                        ? chart.chartArea.height / 1.6
                        : 40,
                  },
                ],
              }}
              // options={{
              //   responsive: true,
              //   maintainAspectRatio: false,

              //   layout: {
              //     padding: {
              //       bottom: 0,    // ab zyada padding ki zarurat nahi
              //     },
              //   },

              //   plugins: {
              //     legend: { display: false },

              //     tooltip: {
              //       callbacks: {
              //         label: (ctx) =>
              //           `${ctx.raw?.x} : ${ctx.raw?.v}`,
              //       },
              //     },

              //     datalabels: {
              //       display: true,
              //       formatter: (ctx) => ctx?.v?.toFixed(2),
              //       color: "#000",
              //       anchor: "center",
              //       align: "center",
              //       font: {
              //         size: 12,
              //         weight: "bold",
              //       },
              //     },
              //   },

              //   scales: {
              //     x: {
              //       type: "category",
              //       labels: users,
              //       ticks: {
              //         autoSkip: false,
              //         maxRotation: 45,
              //         minRotation: 45,
              //         font: {
              //           size: 11,
              //           weight: "bold",
              //         },
              //         color: "#000",
              //       },
              //     },

              //     y: {
              //       type: "category",
              //       labels: ["DATA", ""],   // 🔥 BUFFER ROW
              //     },
              //   },
              // }}

              options={{
                responsive: true,
                maintainAspectRatio: false,

                layout: {
                  padding: {
                    bottom: 50,
                  },
                },

                plugins: {
                  legend: { display: false },

                  tooltip: {
                    callbacks: {
                      label: (ctx) =>
                        `${ctx.raw?.x} : ${ctx.raw?.v}`,
                    },
                  },

                  datalabels: {
                    display: true,
                    formatter: (ctx) => ctx?.v?.toFixed(2),
                    color: "#000",
                    anchor: "center",
                    align: "center",
                    font: {
                      size: 12,
                      weight: "bold",
                    },
                  },
                },

                scales: {
                  x: {
                    type: "category",
                    labels: users,
                    ticks: {
                      autoSkip: false,
                      maxRotation: 45,
                      minRotation: 45,
                      font: {
                        size: 11,
                        weight: "bold",
                      },
                      color: "#000",
                      padding: 10,
                    },
                  },

                  y: {
                    type: "category",
                    labels: ["Today Specific Yield"],
                    offset: true,          // 🔥 CENTER FIX
                    ticks: {
                      font: {
                        size: 12,
                        weight: "bold",
                      },
                      padding: 10,
                    },
                  },
                },
              }}


            />
          )}
        </div>
      </div>

      {/* 🔽 Lower chart */}
      <BusinessInnerSimpleChart4 />
    </>
  );
});

export default BusinessInnerChart4;
